export default __webpack_public_path__ + "static/media/collision-repair.9b540160.png";